import _ from 'lodash'
import {
  Fee,
  BankListResponse,
  PrefillPayload,
  PrefillResponse,
} from '../../components/banklist/typings'

export const fetchBankList = _.memoize(
  async (
    paapiUrl: string,
    purpose: string,
    amount: number,
    term: number,
    advertisementId: string,
  ) => {
    const response: Response = await fetch(
      `${paapiUrl}${advertisementId}?amount=${amount}&term=${term}&purpose=${purpose}`,
    )
    const bankListResponse: BankListResponse = await response.json()

    return bankListResponse
  },
  (...args) => _.values(args).join('_'),
)

export const convertToGermanCurrencyFormat = (fee: Fee) =>
  `${fee.euros},${`${fee.cents}`.toString().padStart(2, '0')}`

export const convertToGermanLocale = (rate: number) =>
  new Intl.NumberFormat('de-DE', undefined).format(rate)

export const getPrefillResponse = _.memoize(async (payload: PrefillPayload) => {
  const response: Response = await fetch(
    process.env.NEXT_PUBLIC_API_PASS_PREFILL || '',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  )
  const prefillResponse: PrefillResponse = await response.json()

  return prefillResponse
})

export const setPrefillResumeHashToStorage = (resumeHash: string) => {
  try {
    localStorage.setItem('PREFILL_RESUME_HASH', resumeHash)
  } catch (ex) {
    // THIRD_PARTY_COOKIE_BLOCKED
  }
}

export const getPrefillResumeHashFromStorage = () => {
  try {
    return localStorage.getItem('PREFILL_RESUME_HASH')
  } catch (ex) {
    // THIRD_PARTY_COOKIE_BLOCKED
  }

  return null
}
